import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["showEveryoneOption", "shareAudience"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import FormField from 'components/FormField';
import RadioButtonOption from 'components/RadioButtonOption';
import Stack from 'components/Stack';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ShareAudienceField(_ref) {
  var _ref$showEveryoneOpti = _ref.showEveryoneOption,
    showEveryoneOption = _ref$showEveryoneOpti === void 0 ? true : _ref$showEveryoneOpti,
    shareAudience = _ref.shareAudience,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    label: t('share_recipients'),
    as: "fieldset"
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [showEveryoneOption && /*#__PURE__*/_jsx(RadioButtonOption, {
        id: "all",
        label: t('state_everyone_in_audience'),
        checked: shareAudience.value === 'all',
        value: "all",
        onChange: function onChange() {
          return shareAudience.set('all');
        }
      }), /*#__PURE__*/_jsx(RadioButtonOption, {
        id: "changed",
        label: t('state_people_with_changed_status'),
        checked: shareAudience.value === 'changed',
        value: "changed",
        onChange: function onChange() {
          return shareAudience.set('changed');
        }
      })]
    })
  }));
}
export default ShareAudienceField;